
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import {
  Dialog,
  Form,
  FormItem,
  Select,
  Option,
  Input,
  Button,
  Row,
  Col,
  Table,
  TableColumn,
  Pagination,
  Tag,
  Loading,
  Message,
} from 'element-ui';
import api from '@/api/course';
import exerciseApi, { batchSaveExercises } from '@/api/exercise';

Vue.use(Loading.directive);

@Component({
  components: {
    Dialog,
    Form,
    FormItem,
    Select,
    Option,
    Input,
    Button,
    Row,
    Col,
    Table,
    TableColumn,
    Pagination,
    Tag,
    Message,
  },
})
export default class AddExerciseQuestionModal extends Vue {
  @Prop({ type: Object, default: () => ({}) }) oldForm!: { chapterPid: string };

  @Prop({ type: String, default: '' }) title!: string;

  @Prop({ type: Boolean, default: false }) visible!: boolean;

  form: { title: string; type: number | undefined; chapterPid: string; pid?: string } = {
    title: '',
    type: undefined,
    chapterPid: '',
  };

  tableData: any[] = [];
  total = 0;
  currentPage = 1;
  pageSize = 20;
  searchLoading = false;
  submitLoading = false;
  selectedRows: any[] = [];
  existingQuestions: number[] = [];

  typeOptions = [
    { value: 0, label: '选择题' },
    { value: 1, label: '判断题' },
    { value: 2, label: '多选题' },
    { value: 3, label: '填空题' },
    { value: 4, label: '编程题' },
    { value: 5, label: '阅读程序题' },
    { value: 6, label: '问答题' },
  ];

  @Watch('visible')
  private onVisibleChange(val: boolean) {
    if (val) {
      this.tableData = [];
      this.total = 0;
      this.selectedRows = [];
      this.loadExistingQuestions();
    }
  }

  private isQuestionExists(row: any) {
    return this.existingQuestions.includes(row.pid);
  }

  private isRowSelectable(row: any) {
    return !this.isQuestionExists(row);
  }

  async handleSelectionChange(selection: any[]) {
    this.selectedRows = selection;
  }

  async searchQuestion() {
    try {
      this.searchLoading = true;
      const params = {
        current: this.currentPage,
        pageSize: this.pageSize,
        params: {
          title: this.form.title || undefined,
          type: this.form.type !== undefined ? this.form.type : undefined,
          questionId: this.form.pid || undefined,
        },
      };
      const res: any = await api.getQJQuestion(params);
      if (res.data) {
        this.tableData = res.data || [];
        this.total = res.total || 0;
      } else {
        Message.error('搜索失败');
      }
    } catch (error) {
      console.error('搜索失败:', error);
      Message.error('搜索失败，请重试');
    } finally {
      this.searchLoading = false;
    }
  }

  async handleSubmit() {
    if (this.selectedRows.length === 0) {
      Message.warning('请选择要添加的题目');
      return;
    }

    this.submitLoading = true;
    try {
      const list = this.selectedRows.map(row => ({
        chapterPid: this.oldForm.chapterPid,
        ojQuestionPid: row.pid,
      }));

      await batchSaveExercises(list);
      Message.success('添加题目成功');

      this.selectedRows = [];
      this.resetForm();
      this.$emit('update:visible', false);
      this.$emit('refrsh');
    } catch (error) {
      console.error('添加题目失败:', error);
      Message.error('添加题目失败，请重试');
    } finally {
      this.submitLoading = false;
    }
  }

  handleCancel() {
    this.$emit('update:visible', false);
    this.resetForm();
  }

  resetForm() {
    this.form = {
      title: '',
      type: undefined,
      chapterPid: '',
    };
    this.selectedRows = [];
  }

  handleCurrentChange(val: number) {
    this.currentPage = val;
    this.searchQuestion();
  }

  handleSizeChange(val: number) {
    this.pageSize = val;
    this.currentPage = 1;
    this.searchQuestion();
  }

  getTypeLabel(value: number | string) {
    const numValue = typeof value === 'string' ? parseInt(value, 10) : value;
    const option = this.typeOptions.find(item => item.value === numValue);
    const result = option ? option.label : `未知类型(${value})`;
    return result;
  }

  private async loadExistingQuestions() {
    try {
      const res: any = await exerciseApi.getExercisesByChapterPidWithQuestionDetails(this.oldForm.chapterPid);
      const list = res && res.data ? res.data : res;
      if (Array.isArray(list)) {
        this.existingQuestions = list
          .map((item: any) => item.question && item.question.pid)
          .filter((pid: any) => pid !== undefined && pid !== null);
      }
    } catch (error) {
      console.error('加载已存在题目失败:', error);
    }
  }
}
